import React, { Component } from 'react';
import PaginationPanel from '@src/components/PaginationPanel/PaginationPanel';
import axiosInstance from '@src/axios-instance';
import Table from '@components/Associations/Table/Table';
import { withRouter } from 'react-router';

class AssociationsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phraze: '',
      loaded: false,
      pagination: {
        loaded: false,
        list: [],
        total: 0,
        page: 1,
        limit: 10,
        start: 0,
        end: 10,
        sort: null,
        direction: null
      }
    };

    const { page, limit, sort, direction } = this.state.pagination;
    this.getList({ page, limit, sort, direction });
  }

  onEntityClick = entityId => {
    this.props.history.push(`/associations/${entityId}`);
  };

  getList = getData => {
    getData.management_company_id = this.props.entityId;
    axiosInstance()
      .get('/associations.json', { params: getData })
      .then(response => {
        this.setState({
          pagination: {
            ...response.data
          },
          loaded: true
        });
      })
      .catch(err => {});
  };

  render = () => {
    const { pagination } = this.state;
    return (
      <React.Fragment>
        <Table
          entities={this.state.pagination.list}
          onEntityClick={entityId => this.onEntityClick(entityId)}
          {...pagination}
          paginationFunc={this.getList}
          showManagementCompany={false}
        />
        <PaginationPanel
          page={pagination.page}
          limit={pagination.limit}
          total={pagination.total}
          start={pagination.start}
          end={pagination.end}
          sort={pagination.sort}
          direction={pagination.direction}
          paginationFunc={this.getList}
          phraze={pagination.phraze}
        />
      </React.Fragment>
    );
  };
}

export default withRouter(AssociationsTable);
